var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBusinessesLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 6,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 12.5L18.6121 12.9836C19.642 13.2926 20.1569 13.4471 20.4535 13.8456C20.75 14.2442 20.75 14.7819 20.75 15.8571V21.5",
    stroke: "black",
    strokeWidth: 1.6,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 11.75H13.25M11 14.75H13.25",
    stroke: "black",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 21.5V19.25C14 18.5429 14 18.1894 13.7803 17.9697C13.5606 17.75 13.2071 17.75 12.5 17.75H11.75C11.0429 17.75 10.6893 17.75 10.4697 17.9697C10.25 18.1894 10.25 18.5429 10.25 19.25V21.5",
    stroke: "black",
    strokeWidth: 1.6,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 21.5H21.5",
    stroke: "black",
    strokeWidth: 1.6,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.25 21.5V10.0379C7.25 8.15487 7.25 7.21333 7.84338 6.74618C8.43678 6.27903 9.31057 6.53266 11.0581 7.03993L14.8081 8.12842C15.8627 8.43453 16.39 8.58758 16.695 9.00474C17 9.4219 17 9.99008 17 11.1264V21.5",
    stroke: "black",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessesLogo);
export default __webpack_public_path__ + "static/media/businesses-logo.b983ef65032190ab04d022664fa703d9.svg";
export { ForwardRef as ReactComponent };